export const loginActionTypes = {
  ISLOGGEDIN: "ISLOGGEDIN",
  LOGIN_DETAILS: "LOGIN_DETAILS",
  SERVICE_LOG_DETAILS: "SERVICE_LOG_DETAILS",
  IS_SERVICE_LOGIN: "IS_SERVICE_LOGIN",
};
